import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"

function useUpdateProfilePicture(userId: number) {
  return useMutation({
    mutationFn: (data: { imageUrl: string }) => {
      return client
        .put(`/users/update-image/${userId}`, data)
        .then((response) => response.data)
    },
  })
}
export default useUpdateProfilePicture
